import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import LoginPage from './pages/login';
import AdministrativeSettings from './pages/administrative-settings';
import QuoteCalculator from './pages/quote-calculator';
import ClientDatabase from './pages/client-database';
import DigitalQuoteReview from './pages/digital-quote-review';
import QuoteManagement from './pages/quote-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/quote-calculator" element={<QuoteCalculator />} />
        
        {/* Protected Routes - require admin authentication */}
        <Route path="/" element={
          <ProtectedRoute>
            <AdministrativeSettings />
          </ProtectedRoute>
        } />
        <Route path="/administrative-settings" element={
          <ProtectedRoute>
            <AdministrativeSettings />
          </ProtectedRoute>
        } />
        <Route path="/client-database" element={
          <ProtectedRoute>
            <ClientDatabase />
          </ProtectedRoute>
        } />
        <Route path="/digital-quote-review" element={
          <ProtectedRoute>
            <DigitalQuoteReview />
          </ProtectedRoute>
        } />
        <Route path="/quote-management" element={
          <ProtectedRoute>
            <QuoteManagement />
          </ProtectedRoute>
        } />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;